import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=36e8b90d&scoped=true"
import script from "./type1.vue?vue&type=script&lang=js"
export * from "./type1.vue?vue&type=script&lang=js"
import style0 from "./type1.vue?vue&type=style&index=0&id=36e8b90d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8b90d",
  null
  
)

export default component.exports